import React, { useState } from "react";
import { t } from "ttag";

import { Modal } from "../../../common/Modal";
import { IModularConfiguratorOptionSet } from "../models";
import { RootProductCompareModalContent } from "./RootProductCompareModalContent";

import styles from "./RootProductCompareModal.module.scss";

interface IProps {
    optionSet: IModularConfiguratorOptionSet;
}

export const RootProductCompareModal = (props: IProps): React.ReactNode => {
    const [isOpen, setIsOpen] = useState(false);

    const onOpen = (e: React.MouseEvent<HTMLButtonElement>): void => {
        e.preventDefault();
        setIsOpen(true);
    };

    const onRequestClose = (): void => {
        setIsOpen(false);
    };

    if (!props.optionSet.root_product_compare_modal) {
        return null;
    }

    return (
        <>
            <button className={styles.openBtn} onClick={onOpen}>
                {t`Compare`}
            </button>
            <Modal
                isOpen={isOpen}
                onRequestClose={onRequestClose}
                className={styles.modalContent}
                aria={{
                    // TODO(i18n): This ID reference "heading" should correspond to a translatable heading element
                    labelledby: "heading",
                }}
            >
                <RootProductCompareModalContent optionSet={props.optionSet} />
            </Modal>
        </>
    );
};
